<template>
    <div
        class="tooltip ml-4 flex cursor-pointer px-2 pb-2"
        v-on:mouseenter="show = true"
        v-on:mouseleave="show = false"
        v-if="tooltip.length > 0"
    >
        <i class="fal fa-info-circle inline-block"></i>
        <transition name="fade">
            <div
                :class="
                    'tip ml-2 p-3 flex-1 max-w-sm absolute z-10 text-xs shadow-sm bg-primaryBlue-20 normal-case ' +
                    transparencyClass
                "
                v-if="show"
            >
                {{ tooltip }}
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        tooltip: {
            type: String,
            required: false,
            default: "",
        },
        transparency: {
            type: String,
            required: false,
            default: "partial",
        },
    },
    data() {
        return {
            show: false,
        };
    },
    methods: {},
    computed: {
        transparencyClass() {
            return this.transparency == "full" ? "opacity-100" : "opacity-70";
        },
    },
};
</script>

<style></style>
